import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilterPresetApiService {
  constructor(private http: HttpClient) {}

  createFilterPreset = (params: Record<string, unknown>) => this.http.post('/api/v1.0/filter-preset', params);

  getFilterPreset = (params: Record<string, string>) =>
    this.http.get(`/api/v1.0/filter-preset`, {
      params,
    });

  getFilterPresetById = (id: string) => this.http.get(`/api/v1.0/filter-preset/${id}`);

  removeFilterPreset = (id: string) => this.http.delete(`/api/v1.0/filter-preset?id=${id}`);

  checkFilterPresetName = (params: Record<string, string>) =>
    this.http.get(`/api/v1.0/filter-preset/name-exists`, {
      params,
    });
}
